/* Biontech Listicle — countdown 24h, sticky CTA, reveal */
(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }

  // Countdown 24h con reinicio diario a la hora configurada (data-reset-hour)
  function initCountdown(el) {
    var resetHour = parseInt(el.getAttribute('data-reset-hour') || '0', 10);
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(resetHour, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var d = end - now;
      var h = Math.floor(d / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
      el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  }

  function init() {
    document.querySelectorAll('[data-lst-countdown]').forEach(initCountdown);

    document.querySelectorAll('[data-lst-sticky]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold') || '900', 10);
      var shown = false;
      window.addEventListener('scroll', function () {
        var next = window.scrollY > threshold;
        if (next !== shown) {
          shown = next;
          bar.classList.toggle('show', shown);
          bar.setAttribute('aria-hidden', String(!shown));
        }
      }, { passive: true });
    });

    var nodes = document.querySelectorAll('.lst-reveal');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
